import * as Sentry from '@sentry/react';
import { useTranslation } from 'react-i18next';

const ErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <div className='flex min-h-screen items-center justify-center bg-b-surface1 p-6 font-inter text-t-primary'>
      <div className='flex w-full max-w-md flex-col items-center gap-4 rounded-2xl border border-primary-03/20 bg-primary-03/10 p-6 text-center'>
        <h1 className='text-h6'>{t('common.unexpected_error')}</h1>
        <p className='text-body-2 text-t-secondary leading-relaxed'>
          {t('common.unexpected_error_description')}
        </p>
        <button
          onClick={() => window.location.reload()}
          className='rounded-lg border border-s-stroke2 px-4 py-2 text-sm font-medium transition-colors hover:bg-b-surface2'
        >
          {t('common.reload')}
        </button>
      </div>
    </div>
  );
};

/**
 * Without a boundary, any throw during render unmounts the entire tree and the
 * user is left with a blank white page and no way back. Keep this at the root
 * so a single bad record degrades into a recoverable message.
 */
export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => (
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    {children}
  </Sentry.ErrorBoundary>
);
